import { render, staticRenderFns } from "./aggregateCard.vue?vue&type=template&id=3ad8aae4&scoped=true&"
import script from "./aggregateCard.vue?vue&type=script&lang=js&"
export * from "./aggregateCard.vue?vue&type=script&lang=js&"
import style0 from "./aggregateCard.vue?vue&type=style&index=0&id=3ad8aae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad8aae4",
  null
  
)

export default component.exports